import React, { useEffect, useState } from "react";
import { Tabs, Tab, Button } from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import "react-phone-input-2/lib/bootstrap.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import girlimg from "../../assets/images/girl.png";
import logowhite from "../../assets/images/logowhite.svg";
import arrowwblack from "../../assets/images/arrow-left.svg";
import addressicon from "../../assets/images/address.svg";
import { authService } from "services";
import { useFormik } from "formik";
import * as Yup from "yup";
import useCountries from "../../hooks/useCountries";
import GoogleMapModal from "../Modals/GoogleMapModal";
import { tabData, tabDescription } from "../../utils";
import Images from "assets/images";

const Signup = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const userType = searchParams.get("userType");
  const [activeTab, setActiveTab] = useState(userType || "CLIENT");
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [userAddress, setUserAddress] = useState(null);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [readOnlyData, setReadOnlyData] = useState({});
  const [location, setLocation] = useState({ lat: 0, lng: 0 });
  const LIVE_SITE_URL = process.env.REACT_APP_LIVE_SITE_URL;

  const { countries = [] } = useCountries() || {};
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      roleType: activeTab,
      firstName: "",
      lastName: "",
      businessName: "",
      email: "",
      countryCode: "+1",
      phone: "",
      address: "",
      countryId: "",
      state: "",
      city: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      firstName: Yup.string().required("Please enter first name").max(30),
      lastName: Yup.string().required("Please enter last name").max(15),
      businessName: Yup.string().optional().max(40),
      email: Yup.string()
        .required("Please enter email")
        .email("Enter valid email")
        .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, "Enter valid email"),
      phone: Yup.string()
        .required("Please enter phone number")
        .matches(/^\d{10}$/, "Please enter a valid 10-digit phone number"),
      address: Yup.string().required("Please enter address"),
      countryId: Yup.string().required("Please select country"),
      state: Yup.string().required("Please enter state"),
      city: Yup.string().required("Please enter city"),
    }),
    onSubmit: async (values) => {
      if (!isTermsAccepted) {
        setError("Please accept terms and conditions!");
        return;
      }

      values.latitude = location.lat;
      values.longitude = location.lng;
      values.countryId = values.countryId || readOnlyData?.country || "";
      values.state = readOnlyData?.state || "";
      values.city = readOnlyData?.city || "";

      try {
        const response = await authService.signup(values);
        if (response?.data?.success) {
          localStorage.setItem("userData", JSON.stringify(values));
          navigate(`/enter-otp?type=SIGN_UP`);
        } else {
          setError(response?.data?.message);
        }
      } catch (err) {
        setError(err?.response?.data?.message || "Signup failed");
      }
    },
  });

  const handleTabChange = (tab) => {
    formik.setFieldValue("roleType", tab);
    formik.resetForm();
    setActiveTab(tab);
    setSearchParams({ userType: tab });
    setIsTermsAccepted(false);
    setError(null);
  };

  const modalCloseHandler = () => setShowModal(false);

  const handleTerms = (e) => {
    setIsTermsAccepted(e.target.checked);
    setError(null);
  };

  useEffect(() => {
    formik.setFieldValue("address", userAddress);
  }, [userAddress, activeTab]);

  useEffect(() => {
    formik.setFieldValue("state", readOnlyData?.state);
    formik.setFieldValue("city", readOnlyData?.city);
  }, [readOnlyData]);

  useEffect(() => {
    formik.setFieldValue("latitude", location.lat);
    formik.setFieldValue("longitude", location.lng);
  }, [location]);

  useEffect(() => {
    if (readOnlyData?.country) {
      formik.setFieldValue("countryId", readOnlyData.country);
    }
  }, [readOnlyData?.country]);


  const handlePhoneChange = (value) => {
    const digitsOnly = value.replace(/\D/g, "");
    const phoneNumber = digitsOnly.startsWith("1") ? digitsOnly.slice(1) : digitsOnly;
    formik.setFieldValue("phone", phoneNumber);
    formik.setFieldValue("countryCode", "+1");
  };


  return (
    <>
      <div className="container-fluid login-page p-0">
        <div className="row relative">
          <div className="col-lg-7 pr-0">
            <div className="right-login-side">
              <div className="nav-bar-container">
                <Link to="/" className="nav-bar">
                  <img alt="" src={Images.arrowleft} className="me-2 py-1" />
                  Home
                </Link>
              </div>

              <div className="outer-div-form">
                <div className="form-div">
                  <img src={Images.drone} alt="logo" className="auth-drone mx-auto d-block" />
                  <h4 className="text-center text-white form-hreading fw-bold">Create an account</h4>
                  <Tabs
                    activeKey={activeTab}
                    onSelect={handleTabChange}
                    className="bg-transparent tab-outer border-0 mx-auto"
                  >
                    {Object.keys(tabData).map((tabName, idx) => (
                      <Tab eventKey={tabName} title={tabData[tabName]} key={`tab${idx}`}>
                        <div className="tab-content-bg">
                        <div className="tab-content auth-tab-content px-lg-5 px-3">
                          {idx === 1 && (
                            <p
                              className="text-center mx-auto pb-2 pt-1"
                              style={{
                                color: "#fff",
                                fontSize: "14px",
                                borderColor: "rgba(255, 255, 255, 0.4)",
                                padding: "20px",
                                borderRadius: "10px",
                                backgroundColor: "rgba(255, 255, 255, 0.05)",
                                minHeight: "85px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {tabDescription?.PILOT}
                            </p>
                          )}

                          <form onSubmit={formik.handleSubmit}>
                            {/* First & Last Name */}
                            <div className="row">
                              <div className="col-lg-6 mb-20 text-left">
                                <label className="py-2">First Name</label>
                                <div className="form-control-bg">
                                <input
                                  type="text"
                                  className="form-control rounded-3 bg-cyan w-100"
                                  placeholder="Enter First Name"
                                  name="firstName"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.firstName}
                                />
                                </div>
                                {formik.touched.firstName && formik.errors.firstName && (
                                  <div className="text-danger">{formik.errors.firstName}</div>
                                )}
                              </div>
                              <div className="col-lg-6 mb-20 text-left">
                                <label className="py-2">Last Name</label>
                                <div className="form-control-bg">
                                <input
                                  type="text"
                                  className="form-control rounded-3 bg-cyan w-100"
                                  placeholder="Enter Last Name"
                                  name="lastName"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.lastName}
                                />
                                </div>
                                {formik.touched.lastName && formik.errors.lastName && (
                                  <div className="text-danger">{formik.errors.lastName}</div>
                                )}
                              </div>
                            </div>

                            {/* Business Name */}
                            {activeTab === "CLIENT" && (
                              <div className="mb-20 text-left">
                                <label className="py-2">Business Name (if any)</label>
                                <div className="form-control-bg">
                                <input
                                  type="text"
                                  className="form-control rounded-3 bg-cyan w-100"
                                  placeholder="Enter Business Name"
                                  name="businessName"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.businessName}
                                />
                                </div>
                                {formik.touched.businessName && formik.errors.businessName && (
                                  <div className="text-danger">{formik.errors.businessName}</div>
                                )}
                              </div>
                            )}

                            {/* Email */}
                            <div className="mb-20 text-left">
                              <label className="py-2">Email</label>
                              <div className="form-control-bg">
                              <input
                                type="text"
                                className="form-control rounded-3 bg-cyan w-100"
                                placeholder="Enter Email"
                                name="email"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.email}
                              />
                              </div>
                              {formik.touched.email && formik.errors.email && (
                                <div className="text-danger">{formik.errors.email}</div>
                              )}
                            </div>

                            {/* Phone */}
                            <div className="mb-20 text-left">
                              <label className="py-2">Mobile Number</label>
                              <div className="form-control-bg">
                              <PhoneInput
                                country="us"
                                onlyCountries={["us"]}
                                disableDropdown
                                countryCodeEditable={false}
                                placeholder="Enter phone number"
                                onChange={handlePhoneChange}
                                onBlur={formik.handleBlur}
                                value={`${formik.values.countryCode}${formik.values.phone}`}
                              />
                              </div>
                              {formik.touched.phone && formik.errors.phone && (
                                <div className="text-danger">{formik.errors.phone}</div>
                              )}
                            </div>

                            {/* Address + Location */}
                            <div className="mb-20 text-left">
                              <label className="py-2">Address</label>
                              <div className="addres-icon rounded-3 w-100 d-flex align-items-center">
                                <div className="form-control-bg">
                                <input
                                  type="text"
                                  className="address-input w-100 bg-transparent border-0"
                                  placeholder="Enter Address"
                                  name="address"
                                  value={formik.values.address}
                                  readOnly
                                />
                                </div>
                                <img
                                  onClick={() => setShowModal(true)}
                                  src={addressicon}
                                  alt="locate"
                                  style={{ cursor: "pointer", filter: "brightness(10)" }}
                                />
                              </div>
                              {formik.touched.address && formik.errors.address && (
                                <div className="text-danger">{formik.errors.address}</div>
                              )}
                            </div>

                            {/* Country, State, City */}
                            <div className="mb-20 text-left">
                              <label className="py-2">Country</label>
                              <div className="form-control-bg">
                              <select
                                className="form-select"
                                name="countryId"
                                value={formik.values.countryId}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                disabled={!!readOnlyData?.country}
                              >
                                <option value="">Country</option>
                                {Array.isArray(countries) &&
                                  countries.map((c) => (
                                    <option key={c._id} value={c._id}>
                                      {c.CountryName}
                                    </option>
                                  ))}
                              </select>
                              </div>
                              {formik.touched.countryId && formik.errors.countryId && (
                                <div className="text-danger">{formik.errors.countryId}</div>
                              )}
                            </div>

                            <div className="mb-20 text-left">
                              <label className="py-2">State</label>
                              <div className="form-control-bg">
                              <input
                                type="text"
                                className="form-control rounded-3 bg-cyan w-100"
                                value={readOnlyData?.state || ""}
                                disabled
                              />
                              </div>
                            </div>
                            <div className="mb-20 text-left">
                              <label className="py-2">City</label>
                              <div className="form-control-bg">
                              <input
                                type="text"
                                className="form-control rounded-3 bg-cyan w-100"
                                value={readOnlyData?.city || ""}
                                disabled
                              />
                              </div>
                            </div>

                            {/* Terms */}
                            <div className="form-check mb-3 text-center">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={isTermsAccepted}
                                onChange={handleTerms}
                              />
                              <label className="form-check-label">
                                By registering you accept our{" "}
                                <Link to="/terms-section">Terms of Services</Link> and{" "}
                                <Link to="/privacy-section">Privacy Policy</Link>
                              </label>
                            </div>

                            {error && <div className="text-danger">{error}</div>}

                            <div className="text-center">
                              <Button type="submit" disabled={formik.isSubmitting} className="btn btn-primary">
                              Create Account
                              </Button>
                            </div>
                          </form>

                          <p className="text-center light-text fw-bold register-bottom-text">
                            Already have an account?{" "}
                            <Link to={`/login?userType=${activeTab}`} className="text-decoration-none fw-bold text-blue">
                              Login Now
                            </Link>
                          </p>
                        </div>
                        </div>
                      </Tab>
                    ))}
                  </Tabs>
                </div>
              </div>

              <div className="d-flex mt-md-0 mt-2 flex-md-row flex-column bottom-ft justify-content-between auth-bottom-links">
                <div className="mb-lg-0 mb-3 d-flex justify-content-md-start justify-content-center">
                  <Link to={`${LIVE_SITE_URL}terms-conditions`}>Terms of Services</Link>
                  <Link to={`${LIVE_SITE_URL}privacy-policy`}>Privacy Policy</Link>
                </div>
                <div className="mb-lg-0 mb-3 d-flex justify-content-md-end justify-content-center">
                  <p>© 2023 SkyyTask. All rights reserved.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-5 pl-0 pr-0 pt-0">
            <div className="left-bg-form">
              <div className="logo-container w-100">
                <Link to="/" className="mx-auto mt-4 d-flex justify-content-center">
                  <img alt="" src={logowhite} className="logo" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <GoogleMapModal
        show={showModal}
        closeHandler={modalCloseHandler}
        setUserAddress={setUserAddress}
        setLocation={setLocation}
        location={location}
        setReadOnlyData={setReadOnlyData}
        countries={countries}
      />
    </>
  );
};

export default Signup;
